// 先 import 所有圖片資源

const APP_CONFIG = {
  // ====================================
  // API 設定
  // ====================================
  api: {
    baseUri: import.meta.env.VITE_API_BASE,
    hostUrl: import.meta.env.VITE_API_HOST,
  },

}

// 若要全域使用，可綁到 window 上
window.APP_CONFIG = APP_CONFIG

export default APP_CONFIG
